module.exports = __webpack_public_path__ + "static/media/control-gris.b94da455.svg";